module.exports = App.OrderItem = DS.Model.extend
  name        : DS.attr 'string'
  amount      : DS.attr 'number'
  price       : DS.attr 'number'
  dish_price  : DS.attr 'number'
  comment     : DS.attr 'string'
  config_text : DS.attr 'string'
  config      : DS.attr 'mixed'
  configurator: DS.attr 'mixed'
  metric           : DS.attr 'boolean'
  price_weight_unit: DS.attr 'string'
  min_qty          : DS.attr 'number'
  delta_qty        : DS.attr 'number'
  weight_unit      : DS.attr 'string'
  excise_unit      : DS.attr 'string'

  is_bonus: DS.attr 'boolean'

  order   : DS.belongsTo 'order',       async: true
  buddy   : DS.belongsTo 'order_buddy', async: true
  dish    : DS.belongsTo 'dish',        async: true

  configString: (->
    config  = @get('config_text')
    comment = @get('comment')

    result = config
    result += " (#{comment})" if comment

    result
  ).property('config_text','comment')

  bonusPriceIsSet: (->
    @get('is_bonus') && @get('price') > 0
  ).property('is_bonus','price')
